<template>
  <bf-row
    type="flex"
    align="middle"
    :class="{ 'header-mobile': isMobile }"
    class="header fix-header header-transparent"
  >
    <div class="layout-flex-container">
      <bf-row :gutter="24" type="flex" class="align-items-center">
        <bf-col :span="12" :mobile="9">
          <bf-link>
            <a :href="homepage" class="menu-brand">
              <img class="logo-img" alt="Bizfly logo" :src="logo" />
            </a>
          </bf-link>
        </bf-col>

        <bf-col :span="12" :mobile="15">
          <bf-row type="flex" class="justify-content-end align-items-center navi-menu">
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item mr-xl"
              >
                <a :href="`tel:${hotline}`" class="menu-link">
                  <span class="menu-content has-icon-img">
                    <img
                      class="icon-img"
                      alt="Bizflylogo"
                      :src="iconPhone" />
                  </span>
                  <span v-show="!isMobile" class="menu-content menu-text">
                    {{ $t('common.hotline') }}
                  </span>
                </a>
              </li>
              <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item mr-xl"
              >
                <a :href="`mailto:${email}`" class="menu-link">
                  <span class="menu-content has-icon-img">
                    <img
                      class="icon-img"
                      alt="Bizflylogo"
                      :src="iconEnvelope" />
                  </span>
                  <span v-show="!isMobile" class="menu-content menu-text">
                    {{ $t('common.email') }}
                  </span>
                </a>
              </li>
              <li class="menu-item">
                <span class="menu-link">
                  <switch-language />
                </span>
              </li>
          </bf-row>
        </bf-col>
      </bf-row><!-- /.row -->
    </div><!-- /.container -->
  </bf-row><!-- /.header -->
</template>

<script>
import { mapGetters } from 'vuex';
import iconPhone from '@/assets/icons/icon_phone.svg';
import logo from '@/assets/images/logo.svg';
import iconEnvelope from '@/assets/icons/icon_envelope.svg';
import { HELPER } from '@/config/urls';
import SwitchLanguage from '@/components/commons/SwitchLanguage.vue';

export default {
  name: 'HeaderTop',
  components: {
    SwitchLanguage,
  },
  data() {
    return {
      homepage: HELPER.HOMEPAGE,
      hotline: HELPER.HOTLINE,
      email: HELPER.EMAIL,
      logo,
      iconPhone,
      iconEnvelope,
    };
  },
  computed: {
    ...mapGetters('device', [
      'isMobile',
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/_variables';

ul, li {
  list-style: none;
}
.logo-img {
  width: 150px;
  max-width: 100%;
}
.has-icon-img .icon-img {
  width: 20px;
  max-width: 100%;
  vertical-align: middle;
}

.header {
  z-index: 1000;
  height: $hd-nav-height;
}
.header.fix-header {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}

.header-transparent {
  & {
    .logo-img.logo-light,
    .icon-img {
        filter: brightness(0) invert(1);
    }
    .menu-text {
      color: #fff;
    }
  }
}
.header.header-mobile {
  height: $hd-nav-height-mb;
}
</style>
